import Card from '../components/common/Card';
import Button from '../components/common/Button';

export default function Registry() {
  // Add your actual registry links here
  const registries = [
    { name: '[Store Name 1]', url: '#', icon: '🎁' },
    { name: '[Store Name 2]', url: '#', icon: '🎁' },
  ];

  return (
    <div className="min-h-screen py-16 bg-gradient-to-br from-mint-light via-cream to-pink-light">
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="text-4xl md:text-5xl text-center mb-12 text-gray-800">
          Gift Registry
        </h1>

        <Card className="mb-8 text-center">
          <p className="text-lg text-gray-700 mb-4">
            Your presence at our wedding is the greatest gift of all.
          </p>
          <p className="text-gray-600">
            However, if you wish to honor us with a gift, we've registered at the following stores:
          </p>
        </Card>

        <div className="grid md:grid-cols-2 gap-6">
          {registries.map((registry, index) => (
            <Card key={index} className="text-center">
              <div className="text-5xl mb-4">{registry.icon}</div>
              <h3 className="text-xl mb-4 text-lavender-dark">{registry.name}</h3>
              <a href={registry.url} target="_blank" rel="noopener noreferrer">
                <Button variant="primary" fullWidth>
                  View Registry
                </Button>
              </a>
            </Card>
          ))}
        </div>

        <Card className="mt-8 text-center bg-lavender-light">
          <p className="text-gray-700">
            💡 <strong>Tip:</strong> Replace the placeholder registry links above with your actual registry URLs
          </p>
        </Card>
      </div>
    </div>
  );
}
